import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class InvoiceItemActions extends Actions{
    static get target(){
        return 'invoiceItems'
    }

    static clear(){
        this.set({})
    }
}


// WEBPACK FOOTER //
// ./actions/InvoiceItemActions.js